var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "3", stroke: "#303030", strokeWidth: "1.5" }),
    React.createElement("rect", { x: "11.25", y: "7", width: "1.5", height: "10", rx: ".75", fill: "#303030" }),
    React.createElement("rect", { x: "17", y: "11.25", width: "1.5", height: "10", rx: ".75", transform: "rotate(90 17 11.25)", fill: "#303030" })
  );
});